import { z } from 'zod';

/** Search-param schema for the `/invoices` route. */
export const invoicesSearchSchema = z.object({
  search: z.string().optional().catch(undefined),
  statuses: z.array(z.string()).optional().catch(undefined),
  /** DEV-4067: "Show deleted" toggle, separate from `statuses`. */
  deleted: z.boolean().optional().catch(undefined),
  investorId: z.string().optional().catch(undefined),
  /** Display name pinned into the Investor filter so its chip can name an investor outside the picker's first page. Never narrows rows. */
  investorName: z.string().optional().catch(undefined),
  providers: z.array(z.string()).optional().catch(undefined),
  /** Which timestamp the period narrows on: `'CREATED'` or `'DUE_DATE'`. */
  periodBasis: z.string().optional().catch(undefined),
  /** Active period preset id (e.g. `'7d'`), `'custom'`, or `null` for "All time". */
  periodPreset: z.string().nullable().optional().catch(undefined),
  /** Resolved ISO (`yyyy-MM-dd`) bounds, kept in sync with the preset. */
  periodFrom: z.string().optional().catch(undefined),
  periodTo: z.string().optional().catch(undefined),
});

export type InvoicesSearch = z.infer<typeof invoicesSearchSchema>;
